import React from 'react'

const WhyTraining = () => {
  return (
    <div className="max-w-[800px] mx-auto">
      <h1 className='text-3xl text-sky-500 text-center font-bold mb-12'>Why is this training?</h1>
      <div>
        <ul className="list-disc list-inside space-y-2 text-gray-700 text-lg">
          <li>Improve knowledge and expertise for the role.</li>
          <li>Work more efficiently for better performance.</li>
          <li>
            Increase self-assurance in handling every task and responsibility.
          </li>
          <li>Minimize mistakes and enhance accuracy in daily tasks.</li>
          <li>
            Ensure a full understanding of the product's features, benefits, and
            usage.
          </li>
          <li>
            Use the product correctly to enhance efficiency, confidence, and
            productivity while minimizing mistakes.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default WhyTraining